import { BaseOutputSchema } from "./BaseOutput";
import { z } from "zod";
import { TaxonomyDtoSchema } from "./TaxonomyDto";
import { RequestTypeStepDtoSchema } from "./RequestTypeStepDto";

export const RequestFormFieldDataOutputSchema = BaseOutputSchema.extend({
    steps: z.array(RequestTypeStepDtoSchema),
    taxonomy: z.array(TaxonomyDtoSchema).nullish(),
    attachmentUploadInfo: z.string().nullish(),
    manualSignRequired: z.boolean().nullable(),
    isManuallySigned: z.boolean().nullable(),
    isMagicLinkAvailable: z.boolean().nullish(),
    sourceTypeId: z.coerce.number().int().nullish()
});

export type RequestFormFieldDataOutput = z.infer<typeof RequestFormFieldDataOutputSchema>;
